const descriptionTitle = {
  '.card &': {
    fontSize: '16px',
    lineHeight: 1.4,
    letterSpacing: '0.02em',
    color: 'kit.text.main',
  },
};

const styles = {
  previewWrapper: (_, video) => ({
    marginBottom: '16px',
    cursor: `${video ? 'pointer' : 'auto'}`,
    '&:hover button': {
      backgroundColor: {
        xs: 'kit.background.purple',
        xl: 'kit.background.turquoise',
      },
      color: {
        xs: 'kit.text.mainInverse',
        xl: 'kit.text.h',
      },
    },
    '&:active button': {
      backgroundColor: 'kit.background.purple',
      color: 'kit.text.accent',
    },
  }),
  preview: {
    borderRadius: '8px',
    overflow: 'hidden',
    position: 'relative',
  },
  iconWrapper: {
    position: 'absolute',
    right: '20%',
    lineHeight: 0,
    width: {
      xs: '22px',
      xl: '30px',
    },
    '& svg': {
      width: '100%',
      height: 'auto',
    },
    '.card &': {
      width: '22px',
    },
  },
  videoButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '0.3s',
    borderRadius: '50%',
    backgroundColor: 'kit.background.purple',
    padding: {
      xs: '10px',
      xl: '10px 12px',
    },
    minWidth: 'unset',
    color: 'kit.text.mainInverse',
    justifyContent: 'flex-end',
    width: {
      xs: '48px',
      xl: '64px',
    },
    height: {
      xs: '48px',
      xl: '64px',
    },
    '.card &': {
      width: '48px',
      height: '48px',
    },
    '&:hover': {
      backgroundColor: {
        xs: 'kit.background.purple',
        xl: 'kit.background.turquoise',
      },
      color: {
        xs: 'kit.text.mainInverse',
        xl: 'kit.text.h',
      },
    },
    '&:active': {
      color: 'kit.text.accent',
    },
  },
  video: (ratio = '16/9') => ({
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    height: {
      xs: `calc(100vw/(${ratio}))`,
      md: `calc(70vw/(${ratio}))`,
    },
    width: {
      xs: '100%',
      md: '70vw',
    },
  }),
  default: {
    ...descriptionTitle,
    color: 'kit.text.secondary',
  },
  white: {
    ...descriptionTitle,
    color: 'kit.text.mainInverse',
    opacity: '0.4',
  },
};

export default styles;
